import CheckBoxGroup from './CheckBoxGroup';

export default CheckBoxGroup;
